module.exports = __webpack_public_path__ + "static/img/Crownlivin_Logo.8da3931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Crownlivin_Logo.png
// module id = cRAY
// module chunks = 0